import { MessageSemantic } from '@komi-app/creator-ui'
import { dcaBaseUrl } from './dca'

export const campaignsUrl = `${dcaBaseUrl}/campaigns`
export const campaignCreateUrl = `${dcaBaseUrl}/campaign-create`
export const smsCampaignCreateUrl = `${dcaBaseUrl}/sms-campaign-create`
export const campaignCreateScheduleUrl = `${dcaBaseUrl}/email-campaign-schedule`
export const smartScheduleFindMoreURL = 'https://support.komi.io/smart-schedule'

export const infoMessage = {
  text: 'Sending too many emails at once will result in emails not getting delivered to your fans. To protect you from this, we might need to stagger this campaign over multiple days.',
  semantic: MessageSemantic.INFO
}

export const atOnceWarningMessage = {
  text: "Sending to everyone at once might have a negative impact on your deliverability. You can still choose to attempt sending to all fans in the selected segments, but your emails might get blocked and / or have a significantly reduced deliverability rate. If we can't send all emails at once, we'll retry the following day.",
  semantic: MessageSemantic.WARNING
}

export const largeSendWarningMessage = {
  text: "We base your email limit on how many fans you've reached out to in the past two weeks. You can still choose to send to the number of fans entered, but your emails might get blocked.",
  semantic: MessageSemantic.WARNING
}
